import React from 'react';

const PhoneOrderHistoryModal = ({ open, onClose, orders, phone }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-xl w-full p-0 relative border border-gray-200">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-[#174540] transition-colors text-xl font-bold focus:outline-none"
          aria-label="Fermer"
        >
          &times;
        </button>
        {/* Header with icon */}
        <div className="flex items-center gap-3 px-8 pt-8 pb-2 border-b border-gray-100">
          <div className="bg-[#174540] text-white rounded-full p-2 flex items-center justify-center">
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-7v-3m0-4h.01" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
          <div>
            <h2 className="text-xl font-bold text-[#174540] leading-tight">Commandes précédentes</h2>
            <div className="text-sm text-gray-500 mt-0.5">pour le numéro <span className="font-semibold text-[#174540]">{phone}</span></div>
          </div>
        </div>
        {/* Table */}
        <div className="max-h-72 overflow-y-auto px-8 py-4">
          <table className="min-w-full text-sm border-separate border-spacing-y-1">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-3 py-2 text-left rounded-tl-lg">Référence</th>
                <th className="px-3 py-2 text-left">Date</th>
                <th className="px-3 py-2 text-left">Total TTC</th>
                <th className="px-3 py-2 text-left rounded-tr-lg">État</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-gray-400 py-8">Aucune commande trouvée pour ce numéro.</td>
                </tr>
              ) : (
                orders.map((order, idx) => (
                  <tr
                    key={order.id}
                    className={`bg-white shadow-sm ${idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100 transition rounded-lg`}
                  >
                    <td className="px-3 py-2 font-medium text-[#174540]">{order.reference}</td>
                    <td className="px-3 py-2">{new Date(order.dateBonCommande).toLocaleString('fr-FR')}</td>
                    <td className="px-3 py-2">{order.totalTTC} DT</td>
                    <td className="px-3 py-2">
                      <span className="inline-block px-2 py-1 rounded text-xs font-semibold bg-[#e6f4ef] text-[#174540]">
                        {order.etat}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {/* Footer button */}
        <div className="px-8 pb-8">
          <button
            onClick={onClose}
            className="w-full py-2 bg-[#174540] text-white rounded-lg font-semibold hover:bg-[#0d2926] transition text-base shadow-md focus:outline-none"
          >
            Ok, continuer
          </button>
        </div>
      </div>
      {/* Animation keyframes */}
      <style>{`
        .animate-fade-in { animation: fadeInModal 0.2s ease; }
        @keyframes fadeInModal { from { opacity: 0; transform: scale(0.97); } to { opacity: 1; transform: scale(1); } }
      `}</style>
    </div>
  );
};

export default PhoneOrderHistoryModal;